import { Pagination } from '@amzn/awsui-components-react';
import { useLocalizedText } from './localizedText';
import { publishKatalMetric } from '../components/katalAnalytics';

export interface OpenEndedPaginationProps {
  loading: boolean;
  currentPage: number;
  totalItemsLength: number;
  pageSize: number;
  lastEvaluatedKey: string | undefined;
  namespaces?: string[];
  onPageChange: (pageIndex: number) => void;
  transactionKeys: {
    next: string;
    previous: string;
    label: string;
  };
  tableName: string;
}

export const OpenEndedPagination = ({
  loading,
  currentPage,
  totalItemsLength,
  pageSize,
  lastEvaluatedKey,
  namespaces = ['translation'],
  onPageChange,
  transactionKeys,
  tableName,
}: OpenEndedPaginationProps) => {
  const { t } = useLocalizedText(namespaces);
  const pagesCount = lastEvaluatedKey
    ? Math.ceil((totalItemsLength * currentPage) / pageSize) + 1
    : currentPage;
  return (
    <Pagination
      disabled={loading}
      openEnd={loading}
      currentPageIndex={currentPage}
      pagesCount={pagesCount}
      ariaLabels={{
        nextPageLabel: t(`${transactionKeys.next}`),
        previousPageLabel: t(`${transactionKeys.previous}`),
        paginationLabel: t(`${transactionKeys.label}`),
      }}
      onChange={({ detail }) => {
        onPageChange(detail.currentPageIndex);
        publishKatalMetric(tableName + '_pageChange', detail.currentPageIndex.toString());
      }}
    />
  );
};
